import styled, { css } from 'styled-components';
import colors from 'Styles/colors';
import { slideIn } from 'Styles/effects';
import { Wrapper } from 'Common/Components/Contextualization/InputFilter/components/DataContainer/styled';
import StandardTextField from 'Common/Components/StandardTextField';
import { Texts } from 'Common/Components/StandardTextField/styled';
import BaseCancelButton from 'shared/ui/CancelButton';
import BaseButton from 'shared/ui/Button';
import { FORM_ACTION_MIN_WIDTH } from 'shared/ui/Button/Button.constants';

export const Modal = styled.div`
  border-radius: 8px 8px 2px 2px;
  box-shadow: 0 2px 50px 0 rgba(0, 0, 0, 0.24);
  border: solid 1px ${({ theme }) => theme.backgrounds.modal};
  background-color: ${({ theme }) => theme.backgrounds.modal};
  border-top: 10px solid #419bf9;
  padding: 35px;
  text-align: left;
  width: 760px;
  margin-right: 5px;
  ${slideIn};
  display: flex;
  flex-direction: column;
  max-height: 85%;

  .modal-dialog {
    margin: 0;
  }

  .modal-content {
    padding: 34px 30px;
  }
`;
Modal.displayName = 'Modal';

export const Title = styled.div`
  font-size: 21.5px;
  font-weight: 600;
  display: inline-block;
  max-width: 250px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: ${({ theme }) => theme.text.modalTitle2};
`;
Title.displayName = 'Title';

export const CreateButton = styled(BaseButton)`
  min-width: ${FORM_ACTION_MIN_WIDTH};
`;
CreateButton.displayName = 'CreateButton';

export const Header = styled.div`
  display: flex;
  align-items: center;
  & > *:first-child {
    margin-right: 18px;
  }
`;
Header.displayName = 'Header';

export const CancelButton = styled(BaseCancelButton)`
  min-width: ${FORM_ACTION_MIN_WIDTH};
  margin-left: auto;
  margin-right: 8px;
`;
CancelButton.displayName = 'CancelButton';

export const Body = styled.div`
  margin-top: 21px;
  padding-right: 8px;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
`;
Body.displayName = 'Body';

export const TopRow = styled.div`
  display: flex;
  width: 100%;
`;
TopRow.displayName = 'TopRow';

export const FieldTitle = styled.div`
  font-size: 12.5px;
  color: ${colors.grey17};
  line-height: 1;
  letter-spacing: 0.09px;
  color: #afb1bc;
  margin-bottom: 5px;
`;
FieldTitle.displayName = 'FieldTitle';

export const FieldTitleDescription = styled(FieldTitle)`
  margin-bottom: 5px;
`;
FieldTitleDescription.displayName = 'FieldTitleDescription';

export const Field = styled.div`
  display: inline-block;
  width: 50%;
  margin-left: ${(props) => (props.index > 0 ? '21px' : '0')};
`;
Field.displayName = 'Field';

export const FieldDescription = styled(Field)`
  width: 100%;
  margin-top: 21px;
  margin-bottom: 5px;

  textarea {
    overflow: hidden;
    resize: none;
  }
`;
FieldDescription.displayName = 'FieldDescription';

export const FieldScope = styled(Field)`
  display: flex;
  width: 100%;
  margin-top: 16px;
  gap: 20px;
`;
FieldScope.displayName = 'FieldScope';

export const FieldScopeColumn = styled(Field)`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 16px;
  gap: 5px;
`;
FieldScopeColumn.displayName = 'FieldScopeColumn';

export const CheckboxContainer = styled.div`
`;
CheckboxContainer.displayName = 'CheckboxContainer';

export const Checkbox = styled.input`
  background-color: ${colors.grey18};
  vertical-align: middle;
  display: inline-block;
  margin-bottom: 2px;
  margin-right: 8px;
`;
Checkbox.displayName = 'Checkbox';

export const CheckboxText = styled.div`
  display: inline-block;
  font-size: 13.5px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;

  svg {
    margin-left: 8px;
    height: 15px;
    width: 15px;
    color: ${colors.grey21}
  }
`;
CheckboxText.displayName = 'CheckboxText';

export const SecondTitle = styled.div`
  font-size: 14.5px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  margin-top: 21px;
`;
CheckboxText.displayName = 'CheckboxText';

export const SubTitle = styled.div`
  font-size: 12.5px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  margin-top: 5px;
  margin-bottom: 20px;
  color: ${({ theme }) => theme.text.blueSubtitle};
`;
SubTitle.displayName = 'SubTitle';

export const UserSelectorWrapper = styled.div`
  input {
    width: 100%;
  }

  ${Wrapper} {
    width: 100%;
    max-height: 125px;
    overflow-x: hidden;
  }
`;
UserSelectorWrapper.displayName = 'UserSelectorWrapper';

export const UserSelect = styled.div`
  max-height: 102px;
  border-radius: 3px;
  border: solid 1px ${({ theme }) => theme.borders.assignedUserList};
  background-color: ${({ theme }) => theme.backgrounds.workspaceList};
  margin-top: 21px;
  overflow-y: scroll;
  overflow-x: hidden;
`;
UserSelect.displayName = 'UserSelect';

export const TextAreaContainer = styled.div`
  width: 100%;
  div {
    width: 100%;
    margin-bottom: 0px;
  }
`;
TextAreaContainer.displayName = 'TextAreaContainer';

export const ErrorMessage = styled.div`
  height: 12px;
  margin-top: 15px;
  color: ${colors.redPink};
  font-size: 10.5px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.08px;
`;
ErrorMessage.displayName = 'ErrorMessage';

export const UserRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 33px;
`;
UserRow.displayName = 'UserRow';

const Row = styled.div`
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-stretch: normal;
  font-style: normal;
  font-size: 12.5px;
  padding: 10px;
`;
Row.displayName = 'Row';

export const NameRow = styled(Row)`
  font-weight: 300;
  color: ${({ theme }) => theme.text.modalTitle};
`;
NameRow.displayName = 'NameRow';

export const RoleRow = styled(Row)`
  font-size: 12.5px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  white-space: nowrap;
  color: ${({ role }) => {
    if (role === 'admin') return colors.warmPurple;
    if (role === 'workspace_admin') return colors.green3;
    if (role === 'pentester') return colors.redPink;
    if (role === 'client') return colors.blueCerulean;
    if (role === 'asset_owner') return colors.softBlue;
    return colors.softBlue;
  }};
`;
RoleRow.displayName = 'RoleRow';

const WorkspaceRemoveIcon = styled.div`
  color: ${({ theme }) => theme.icons.actionBar.color} !important;
  float: right;
  margin-left: 21px;
  position: relative;
  top: 4px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  padding: 0px 5px;
  cursor: pointer;
  svg {
    color: ${({ theme }) => theme.icons.actionBar.color} !important;
  }
  &:hover {
    background-color: #90a9c0;
    svg {
      color: ${({ theme }) => theme.icons.actionBar.color} !important;
    }
  }
`;
WorkspaceRemoveIcon.displayName = 'WorkspaceRemoveIcon';

export const IconRow = styled(WorkspaceRemoveIcon)`
  float: none;
  position: static;
  top: auto;
  margin-left: 0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  & svg {
    color: ${({ theme }) => theme.icons.actionBar.color} !important;
  }
`;
IconRow.displayName = 'IconRow';

export const TextField = styled(StandardTextField)`
  width: ${(props) => (props.fullwidth ? '100%' : '50%')};
  height: min-content;
  
  span {
    font-weight: 400;
    line-height: 1;
    margin-bottom: 0px;
  }

  ${({ required }) => required && css`
    ${Texts} span:first-child::after {
      content: ' *';
      color: ${colors.redPink};
      font-weight: 700;
    }
  `}

  input {
    border-bottom: 1px solid transparent;
    box-shadow: ${({ error }) => (error ? `0 1px 0 0 ${colors.redPink}` : 'none')};
    margin-top: 5px;
    background-color: ${({ theme }) => theme.textfield.background};
    color: ${({ theme }) => theme.textfield.text};
    &:focus {
      background-color: ${({ theme }) => theme.textfield.focus};
    }
  }

  span:not(:first-child) {
    margin-top: 4px;
  }
  svg {
    top: 28px;
  }

  ${Texts} {
    height: min-content;
  }
`;
TextField.displayName = 'TextField';

export const TextSpan = styled.span`
font-size: 12.5px;
color: ${({ theme }) => theme.text.modalTitle2};
margin-left: 10px;
line-height: 1;
height: fit-content;
font-weight: 300;
`;
TextSpan.displayName = 'TextSpan';

export const Flex = styled.div`
  display: flex;
  justify-content: ${({ justify }) => justify || 'flex-start'};
  align-items: ${({ align }) => align || 'flex-start'};
`;

Flex.displayName = 'Flex';

export const FieldExplore = styled(Field)`
  width: 100%;
  margin-top: 20px;
`;
FieldExplore.displayName = 'FieldExplore';

export const GroupByControl = styled.div`
  width: 100%;
  height: 34px;
  margin-top: 5px;
  display: flex;
  align-items: center;

  border-radius: 2px;
  border: 1px solid ${({ theme }) => theme.borders?.textfield || 'transparent'};
  background-color: ${({ theme }) => theme.textfield.background};
  overflow: hidden;

  &:focus-within {
    background-color: ${({ theme }) => theme.textfield.focus};
  }

  opacity: ${({ disabled }) => (disabled ? 0.65 : 1)};
`;
GroupByControl.displayName = 'GroupByControl';

export const GroupBySelect = styled.select`
  flex: 1;
  height: 100%;
  border: 0;
  outline: none;
  background: transparent;
  color: ${({ theme }) => theme.textfield.text};
  background-color: ${({ theme }) => theme.backgrounds.workspaceList};
  padding: 0 10px;

  appearance: none;
`;
GroupBySelect.displayName = 'GroupBySelect';

export const MatchPrecisionBox = styled.div`
  height: 100%;
  min-width: 78px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  gap: 4px;

  border-left: 1px solid ${({ theme }) => theme.borders?.textfield || '#d8dbe6'};
  position: relative;
`;
MatchPrecisionBox.displayName = 'MatchPrecisionBox';

export const MatchPrecisionTooltip = styled.div`
  position: absolute;
  top: -26px;
  right: 6px;
  padding: 4px 8px;
  border-radius: 3px;

  font-size: 11px;
  background: #f3e7c7; /* similar al hint de tu screenshot */
  color: #1c4566;

  opacity: 0;
  transform: translateY(2px);
  pointer-events: none;
  transition: opacity 120ms ease, transform 120ms ease;
`;
MatchPrecisionTooltip.displayName = 'MatchPrecisionTooltip';

export const MatchPrecisionInput = styled.input`
  width: 44px;
  border: 0;
  outline: none;
  background: transparent;
  color: ${({ theme }) => theme.textfield.text};
  text-align: right;
`;
MatchPrecisionInput.displayName = 'MatchPrecisionInput';

export const MatchPrecisionSuffix = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.textfield.text};
  opacity: 0.85;
`;
MatchPrecisionSuffix.displayName = 'MatchPrecisionSuffix';

export const MatchPrecisionHoverArea = styled.div`
  height: 100%;
  display: flex;
  align-items: center;

  &:hover ${MatchPrecisionTooltip} {
    opacity: 1;
    transform: translateY(0);
  }
`;
MatchPrecisionHoverArea.displayName = 'MatchPrecisionHoverArea';
